import { useState, useMemo, memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { AssetCopierPanel } from 'ui-multi-account-asset-copier';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function MultiAccountCopyAction({
  selectedObjects
}) {
  const [showCopyToAccountPanel, setShowCopyToAccountPanel] = useState(false);
  const assetsToCopy = useMemo(() => {
    return selectedObjects.map(form => ({
      assetId: String(getPropertyValue(form, 'hs_form_id') || ''),
      assetName: String(getPropertyValue(form, 'hs_name') || ''),
      portableType: 'forms',
      metadata: {
        forms: {
          formType: String(getPropertyValue(form, 'hs_form_type') || '')
        }
      }
    }));
  }, [selectedObjects]);
  const onClickCopyToAccountButton = () => {
    setShowCopyToAccountPanel(true);
  };
  if (assetsToCopy.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Link, {
      "data-test-id": "multi-account-copy-forms-link",
      onClick: onClickCopyToAccountButton,
      children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.table.tableActions.multiAccountCopy"
      })]
    }), showCopyToAccountPanel && /*#__PURE__*/_jsx(AssetCopierPanel, {
      portableType: "forms",
      onClose: () => setShowCopyToAccountPanel(false),
      assets: assetsToCopy
    })]
  });
}
export default /*#__PURE__*/memo(MultiAccountCopyAction);